import { ButtonTypes, ButtonShapes } from "../Button/interface";
import { IconNames } from "../../Foundation/Icons";
import { FeatureAttribution } from "../../shared/interfaces/featureAttribution";
import React from "react";
export enum NavigationThemes {
    BLACKANDWHITE = "blackAndWhite",
}

export interface LinkProps {
    url: string;
    external?: boolean;
    label: string;
    featureAttribution?: FeatureAttribution;
}

export interface NavLinkProps extends LinkProps {
    orientation?: string;
    theme?: string;
}

export interface NavButtonProps {
    label: string;
    onClick: () => void;
    size: string;
    variant?: string;
    orientation?: string;
    theme?: string;
    type?: ButtonTypes;
    name?: IconNames;
    shape?: ButtonShapes;
    iconColour?: string;
    ariaPressed?: boolean;
}
export interface NavigationProps {
    links: (NavLinkProps | NavButtonProps)[];
    orientation?: string;
    theme?: string;
    className?: string;
    iconColour?: string;
    featureAttribution?: FeatureAttribution;
    useInternalScroll?: boolean;
    navIconElement?: React.ReactNode;
}
